/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Answer_Correct_AlreadyInputs */

const en_player_answer_correct_already = /** @type {(inputs: Player_Answer_Correct_AlreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already answered correctly`)
};

const ja_player_answer_correct_already = /** @type {(inputs: Player_Answer_Correct_AlreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`既に正解しました`)
};

const fr_player_answer_correct_already = /** @type {(inputs: Player_Answer_Correct_AlreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déjà répondu correctement`)
};

const de_player_answer_correct_already = /** @type {(inputs: Player_Answer_Correct_AlreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereits richtig beantwortet`)
};

/**
* | output |
* | --- |
* | "Already answered correctly" |
*
* @param {Player_Answer_Correct_AlreadyInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const player_answer_correct_already = /** @type {((inputs?: Player_Answer_Correct_AlreadyInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Answer_Correct_AlreadyInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_player_answer_correct_already(inputs)
	if (locale === "ja") return ja_player_answer_correct_already(inputs)
	if (locale === "fr") return fr_player_answer_correct_already(inputs)
	return de_player_answer_correct_already(inputs)
});